function Intro() {
  return (
    <div
      className="alert alert-success">
      <h1 style={{ fontSize: '24px', marginBottom: '10px' }}>
        <b>Do Calculate: One of the Largest Websites for Free Online Calculators</b>
      </h1>
      <p>
        "Do Calculate" is the leading  platform that provides you with a comprehensive range of free online calculators to help you perform calculations quickly and accurately in fields such as finance, fitness, health, education, mathematics, algebra, trigonometry, fractions, physics, statistics, technology, time management, and more.
      </p>
      <hr />
    </div>
  );
}
export default Intro;
